import { GOOGLE_BUSINESS } from '../config/googleBusiness';

// Use the store's clock, not the visitor's timezone. Intl handles Chicago DST.
export function isStoreOpenAt(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: GOOGLE_BUSINESS.timeZone, weekday: 'short',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(date);
  const value = type => parts.find(part => part.type === type)?.value;
  const hours = GOOGLE_BUSINESS.businessHours[value('weekday')];
  const minute = Number(value('hour')) * 60 + Number(value('minute'));
  return !!hours && minute >= hours[0] && minute < hours[1];
}
const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const fmtTime = (m) => { const h = Math.floor(m / 60), mm = m % 60; return `${h % 12 || 12}${mm ? `:${String(mm).padStart(2, '0')}` : ''} ${h < 12 ? 'AM' : 'PM'}`; };

// "at 10 AM", "tomorrow at 10 AM" or "Mon at 10 AM" — when the store next opens (store clock).
export function nextOpenLabel(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: GOOGLE_BUSINESS.timeZone, weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(date);
  const value = type => parts.find(part => part.type === type)?.value;
  const today = DAYS.indexOf(value('weekday'));
  const minute = Number(value('hour')) * 60 + Number(value('minute'));
  for (let offset = 0; offset < 7; offset += 1) {
    const day = DAYS[(today + offset) % 7];
    const hours = GOOGLE_BUSINESS.businessHours[day];
    if (!hours || (offset === 0 && minute >= hours[0])) continue;
    const when = fmtTime(hours[0]);
    return offset === 0 ? `at ${when}` : offset === 1 ? `tomorrow at ${when}` : `${day} at ${when}`;
  }
  return 'on our next business day';
}
